enum GoogleEmbedType {
    FOLDERS = 'FOLDERS',
    DOCUMENT = 'DOCUMENT',
    PRESENTATION = 'PRESENTATION',
    SPREADSHEETS = 'SPREADSHEETS',
}

export default GoogleEmbedType;
